
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter" />
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm" :rules="rules">
          <div class="lg:mb-2">
            <!-- #region Fecha de Factura -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.invoice_date_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaFacturaDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaFacturaDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaFacturaHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaFacturaHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Fecha Alta -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.fecha_alta_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaAltaDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaAltaDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaAltaHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaAltaHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Fecha Pago -->
            <div v-if="isGeneralStatus || [18,'18'].includes(status)">
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.fecha_pago_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaPagoDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaPagoDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaPagoHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaPagoHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->
            
            <!-- #region Fecha Rechazo -->
            <div v-if="isGeneralStatus || [17,'17'].includes(status)">
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.fecha_rechazo_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaRechazoDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaRechazoDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaRechazoHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaRechazoHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Fecha de Contabilizacion -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.erp_entry_date_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="fechaEntradaERPDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaEntradaERPDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="fechaEntradaERPHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.fechaEntradaERPHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Importe -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.invoice_importe_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="importeDesde">
                        <el-input clearable class="w-full" v-model="form.importeDesde.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label
                        class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="importeHasta">
                        <el-input clearable class="w-full" v-model="form.importeHasta.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Metadatos -->
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $tc('invoices.metadatos.metadato', 2) }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <base-metadato-form-item v-for="(metadato, index) in form.metadatos.value" :key="`metadato.${index}`" :custom="index !== 0 ? 'border-primary-100 dark:border-darkblue-600 border-t pt-4' : ''" :campoProp="`metadato.${index}.campo`" :valorProp="`metadato.${index}.valor`"
                      :idCliente="idCliente" :clientMetadatasList="finalListMetadatasClient" :metadato="metadato" :required="{ campo: !!(metadato.campo || metadato.value), valor: !!(metadato.campo || metadato.value) }" showOperator @change="handleMetadatoChange(index, ...arguments)" />
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Distribuidor + Cliente -->
            <div
              v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.entity_name')}}</label>
                <el-form-item prop="distribuidor">
                  <base-el-select class="w-full" :options="distribuidores" v-model="form.distribuidor.value" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
              <el-form-item prop="empresa">
                <base-el-select class="w-full" :options="clientes" v-model="form.empresa.value" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Numero de Factura -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.num_factura') }}</label>
              <el-form-item prop="numFactura">
                <el-input clearable class="w-full" v-model="form.numFactura.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Emisor (Nombre + CIF + CodigoCliente) -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.emisor') }}</label>
              <el-form-item prop="NombreCIFEmisor">
                <el-input clearable class="w-full" v-model="form.NombreCIFEmisor.value" maxlength="255" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.cif_emisor') }}</label>
              <el-form-item prop="cifEmisor">
                <el-input clearable class="w-full" v-model="form.cifEmisor.value" maxlength="50" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.client_code') }}</label>
              <el-form-item prop="CodCliente">
                <el-input clearable class="w-full" v-model="form.CodCliente.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Recptor (Nombre + CIF) -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.receptor') }}</label>
              <el-form-item prop="NombreCIFReceptor">
                <el-input clearable class="w-full" v-model="form.NombreCIFReceptor.value" maxlength="255" />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.cif_receptor') }}</label>
              <el-form-item prop="cifReceptor">
                <el-input clearable class="w-full" v-model="form.cifReceptor.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Forma de Recepcion / PGE -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.forma_recepcion') }}</label>
              <el-form-item prop="PGE">
                <base-el-select :options="pgeTypes" v-model="form.PGE.value" class="w-full" clearable filterable />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region DIRe / DIR3 -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_rec.dir3_dire') }}</label>
              <el-form-item prop="dirReceptor">
                <el-input clearable class="w-full" v-model="form.dirReceptor.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region CSV -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.csv') }}</label>
              <el-form-item prop="csv">
                <el-input clearable class="w-full" v-model="form.csv.value" maxlength="100" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Motivo de rechazo -->
            <div v-if="motivoRechazoActive">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.reject_msgs')}}</label>
              <el-form-item prop="motivoRechazo">
                <el-input
                  type="textarea"
                  :rows="3"
                  clearable
                  class="w-full"
                  v-model="form.motivoRechazo.value"
                  maxlength="500"
                />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Error temporal -->
            <div v-if="ultimoErrorActive">
              <label
                class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.error_temporal') }}</label>
              <el-form-item prop="ultimoError">
                <el-input type="textarea" :rows="3" clearable class="w-full" v-model="form.ultimoError.value"
                  maxlength="500" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Estado -->
            <div v-if="isGeneralStatus">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.status') }}</label>
              <el-form-item prop="estadoExtraRecibidas">
                <base-el-select :options="tiposEstados" v-model="form.estadoExtraRecibidas.value" class="w-full" clearable filterable
                  multiple />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <div v-if="hasApprovalWorkflowModule">
              <!-- #region Pendiente aprobación -->
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('tipos.estado_recibidas.wait_approving')}}</label>
                <el-form-item prop="pendienteAprobacion">
                  <base-el-select class="w-full" :options="values" v-model="form.pendienteAprobacion.value" clearable :placeholder="$t('invoices.filters.pending_yes_no')" />
                </el-form-item>
              </div>
              <!-- #endregion -->
  
              <!-- #region Pendiente revisión -->
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('tipos.estado_recibidas.wait_reviewing')}}</label>
                <el-form-item prop="esOCREditable">
                  <base-el-select class="w-full" :options="values" v-model="form.esOCREditable.value" clearable :placeholder="$t('invoices.filters.pending_yes_no')" />
                </el-form-item>
              </div>
              <!-- #endregion -->

              <!-- #region Es turno -->
              <div v-if="role !== 3 && role !== 8">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('approval_workflow.workflow_turn') }} </label>
                <el-form-item prop="esTurnoUsuario">
                  <base-el-select class="w-full" :options="values" v-model="form.esTurnoUsuario.value" clearable :placeholder="$t('invoices.filters.workflow_yes_no')" />
                </el-form-item>
              </div>
              <!-- #endregion -->
            </div>

            <!-- #region Serie de Factura -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.serie_factura') }}</label>
              <el-form-item prop="SerieFactura">
                <el-input clearable class="w-full" v-model="form.SerieFactura.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Numero de Asiento -->
            <div>
              <label
                class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.seat_number') }}</label>
              <el-form-item prop="NumAsiento">
                <el-input clearable class="w-full" v-model="form.NumAsiento.value" maxlength="100" />
              </el-form-item>
            </div>
            <!-- #endregion -->
            
            <!-- #region Notas -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.notas') }}</label>
              <el-form-item prop="notas">
                <el-input clearable class="w-full" v-model="form.notas.value" maxlength="500" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Contiene Adjuntos -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.adjuntos_included') }}</label>
              <el-form-item prop="contieneAdjuntos">
                <base-el-select class="w-full" :options="values" v-model="form.contieneAdjuntos.value" clearable :placeholder="$t('invoices.adjuntos_included')" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Grupos -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('groups.entity_name') }}</label>
              <el-form-item prop="nombreGrupo">
                <base-el-select class="w-full" :groups="listaGroupsGrouping" v-model="form.nombreGrupo.value" clearable filterable :loading="loadingGrupos" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('groups.group_owner') }}</label>
              <el-form-item prop="nombreGrupoPropietario">
                <base-el-select class="w-full" :groups="listaGroupsGroupingOwner" v-model="form.nombreGrupoPropietario.value" clearable filterable
                  :loading="loadingGrupos" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Agrupaciones (CIFs) -->
            <div v-if="hasModuleAgrupaciones">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('grouping.grouping_companies', 1)}}</label>
                <el-form-item prop="agrupacionCIF">
                  <el-select class="w-full" v-model="form.agrupacionCIF.value" clearable filterable :placeholder="$t('app.select')">
                      <el-option
                        v-for="(item, index) in listGroupingEmpresas"
                        :key="index"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                </el-form-item>
              </div>
            </div>
            <!-- #endregion -->

            <!-- #region Origen Factura -->
            <div v-if="role === 3">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('invoices.filters.origen_factura')}}</label>
                <el-form-item prop="OrigenFactura">
                  <base-el-select class="w-full" v-model="form.OrigenFactura.value" :options="tiposOrigenFactura" clearable filterable />
                </el-form-item>
              </div>
            </div>
            <!-- #endregion -->

            <!-- <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('invoices.tipo_factura')}}</label>
              <el-form-item prop="tipo">
                <base-el-select class="w-full" :options="types" v-model="form.tipoFactura.value" filterable />
              </el-form-item>
            </div> -->

            <!-- <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('invoices.tipo_factura')}}</label>
              <el-form-item prop="tipoInvoiceClass">
                <base-el-select class="w-full" :options="tiposInvoiceClass" v-model="form.tipoInvoiceClass.value" clearable filterable />
              </el-form-item>
            </div> -->

            <!-- <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('invoices.filters.textoLibre')}}</label>
              <el-form-item prop="textoLibre">
                <el-input
                  type="textarea"
                  :rows="3"
                  clearable
                  class="w-full"
                  v-model="form.textoLibre.value"
                  maxlength="500"
                />
              </el-form-item>
            </div> -->

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters" :loading="isLoading" />
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { getCamposMetadatos } from '@/services/clients/lists/getCamposMetadatos'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'

import { getAgrupacionesNombreCompanies } from '@/services/configurations/grouping/getAgrupacionesNombreCompanies'

export default {
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 99999
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingMetadatos: false,
      loadingClientes: false,
      loadingGrupos: false,
      types: [],
      listMetadatasClient: [],
      finalListMetadatasClient: [],
      maxMetadatosFilter: 5,
      form: {
        estado: { label: i18n.t('app.status'), value: '' },
        pendienteAprobacion: { label: i18n.t('tipos.estado_recibidas.wait_approving'), value: '' },
        esOCREditable: { label: 'Pendiente de revisión', value: '' },
        esTurnoUsuario: { label: 'Es turno', value: '' },
        estadoExtraRecibidas: { label: i18n.t('app.status'), value: '' },
        fechaFacturaDesde: { label: i18n.t('invoices.filters.invoice_date_from'), value: '' },
        fechaFacturaHasta: { label: i18n.t('invoices.filters.invoice_date_to'), value: '' },
        tipoInvoiceClass: { label: i18n.t('invoices.tipo_factura'), value: '' },
        PGE: { label: i18n.t('app.forma_envio'), value: '' },
        dirReceptor: { label: i18n.t('companies.configuration_rec.dir3_dire'), value: '' },
        importeDesde: { label: i18n.t('invoices.filters.invoice_importe_min'), value: '' },
        importeHasta: { label: i18n.t('invoices.filters.invoice_importe_max'), value: '' },
        numFactura: { label: i18n.t('invoices.num_factura'), value: '' },
        SerieFactura: { label: i18n.t('invoices.serie_factura'), value: '' },
        cifEmisor: { label: i18n.t('invoices.cif_emisor'), value: '' },
        NombreCIFEmisor: { label: i18n.t('invoices.emisor'), value: '' },
        CodCliente: { label: i18n.t('invoices.seller_client_code'), value: '' },
        cifReceptor: { label: i18n.t('invoices.cif_receptor'), value: '' },
        NombreCIFReceptor: { label: i18n.t('invoices.receptor'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        importe: { label: i18n.t('invoices.importe'), value: '' },
        nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
        nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
        notas: { label: i18n.t('invoices.notas'), value: '' },
        contieneAdjuntos: { label: i18n.t('invoices.adjuntos_included'), value: '' },
        csv: { label: i18n.t('invoices.csv'), value: '' },
        NumAsiento: { label: i18n.t('invoices.seat_number'), value: '' },
        fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        fechaEntradaERPDesde: { label: i18n.t('invoices.filters.erp_entry_date_from'), value: '' },
        fechaEntradaERPHasta: { label: i18n.t('invoices.filters.erp_entry_date_to'), value: '' },
        ultimoError: { label: i18n.t('invoices.error_temporal'), value: '' },
        motivoRechazo: { label: i18n.t('configurations.reject_msgs'), value: '' },
        metadatos: { label: i18n.tc('invoices.metadatos.metadato', 1), value: [{ campo: '', valor: '', operador: 1, }] },
        agrupacionCIF: { label: i18n.tc('grouping.grouping_companies', 1), value: '' },
        agrupacionCliente: { label: i18n.tc('grouping.grouping_buyers', 1), value: '' },
        agrupacionProveedor: { label: i18n.tc('grouping.grouping_sellers', 1), value: '' },
        OrigenFactura: { label: i18n.t('invoices.origen_factura'), value: '' },
        fechaPagoDesde: { label: i18n.t('invoices.filters.fecha_pago_from'), value: '' },
        fechaPagoHasta: { label: i18n.t('invoices.filters.fecha_pago_to'), value: '' },
        fechaRechazoDesde: { label: i18n.t('invoices.filters.fecha_rechazo_from'), value: '' },
        fechaRechazoHasta: { label: i18n.t('invoices.filters.fecha_rechazo_to'), value: '' },
      },
      listGroupingEmpresas: [],
      distribuidores: [],
      clientes: [],
      valuesNombresGroups: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasAgrupacionesModule']
    },
    hasApprovalWorkflowModule: function () {
      return this.$store.getters['auth/hasApprovalWorkflowModule']
    },
    actualPath: function () {
      return this.$store.getters['app/actualRoute']
    },
    ultimoErrorActive: function () {
      return true
      // return this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoicesreceived/9' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoices/-1' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoices/notices/error'
    },
    motivoRechazoActive: function () {
      // return true
      return this.isGeneralStatus || ['17', 17].includes(this.status)
    },
    isGeneralStatus: function () {
      return this.status === '99999' || this.status === 99999
    },
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.valuesNombresGroups.reduce((a, b) => ({ ...a, [groupTypes[b.idTipoGrupo]?.name]: [...(a[groupTypes[b.idTipoGrupo]?.name] || []), b] }), {})
    },
    listaGroupsGroupingOwner () {
      const tipoReparto = this.tiposGrupo.find(x => x.id === 3)?.name ?? 'Reparto'
      return this.discard([tipoReparto], this.listaGroupsGrouping)
    },
    isLoading: function () {
      return this.loadingClientes || this.loadingGrupos || this.loadingMetadatos || this.loadingDistribuidores
    },
    idCliente: function () {
      return this.clientes.find(x => x.Nombre === this.form.empresa?.value)?.idCliente
    },
    rules: function () {
      const rules = {}
      if (Array.isArray(this.form.metadatos.value)) {
        this.form.metadatos.value.forEach((x, i) => {
          const campo = [
            {
              required: true,
              message: i18n.t('validation.complete'),
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (value === '' && x.valor !== '') {
                  callback(new Error(i18n.t('validation.complete')))
                } else {
                  callback()
                }
              }
            },
            {
              required: true,
              message: i18n.t('app.fill_data'),
              trigger: 'change',
              validator: (rule, value, callback) => {
                if (value === '' && x.valor !== '') {
                  callback(new Error(i18n.t('validation.complete')))
                } else {
                  callback()
                }
              }
            }
          ]
          const valor = [
            {
              required: true,
              message: i18n.t('validation.complete'),
              trigger: 'blur',
              validator: (rule, value, callback) => {
                if (value === '' && x.campo !== '') {
                  callback(new Error(i18n.t('validation.complete')))
                } else {
                  callback()
                }
              }
            },
          ]
          rules[`metadatos.${i}.campo`] = campo
          rules[`metadatos.${i}.valor`] = valor
        })
      }
      return rules
    },
    // tiposInvoiceClass: function () {
    //   return this.$store.getters[`config/TIPOS_INVOICE_CLASS`]
    // },
    tiposEstados: function () {
      return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE_RECEPCION'].concat(this.$store.getters['config/TIPOS_PGE_RECEPCION_IA'])
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    tiposOrigenFactura: function () {
      return this.$store.getters['config/TIPOS_ORIGEN_FACTURA'].filter(x => ['PORTAL', 'API'].includes(x.id))
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    },
    finalListMetadatasClient: function (value, oldValue) {
      this.cleanMetadatos(false)
      this.listMetadatasClient = value
    },
    'form.empresa.value': function (value, oldValue) {
      if (value !== oldValue) {
        this.reloadMetadataList()
      }
    },
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
    if (this.hasModuleAgrupaciones) {
      const dataAgrupacionesEmpresas = await getAgrupacionesNombreCompanies()
      if (dataAgrupacionesEmpresas.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataAgrupacionesEmpresas))
      }
      this.listGroupingEmpresas = dataAgrupacionesEmpresas.Respuesta
    }
    // await this.$store.dispatch('app/getInvoicesTypes')
    // this.types = await this.$store.getters['app/invoicesTypes'].map(x => ({ label: x.valor, value: x.id }))
    
    this.loadingGrupos = true
    const groupsUsuario = await getGroupsNames()
    if (groupsUsuario.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', groupsUsuario))
    } else {
      groupsUsuario.Respuesta.map(item => {
        item.Tipo = this.tiposGrupo.find(x => x.temp === item.Tipo)?.name ?? item.Tipo
      }) 
      this.valuesNombresGroups = groupsUsuario.Respuesta
    }
    this.loadingGrupos = false

    this.reloadMetadataList()

    this.$store.dispatch('app/settiposPGE', this.pgeTypes)
  },
  methods: {
    handleMetadatoChange: function (index, value, oldValue) {
      const operators = [4, 5]
      if ((value.valor !== '' && oldValue.valor === '') || (value.campo !== '' && oldValue.campo === '') || (operators.includes(value.operador) && !operators.includes(oldValue.operador))) {
        if (value.campo !== '' && (value.valor !== '' || operators.includes(value.operador)) && this.form.metadatos.value.length < this.maxMetadatosFilter) {
          this.form.metadatos.value.push({ campo: '', valor: '', operador: 1, })
        }
      } else if ((oldValue.valor !== '' && value.valor === '') || (oldValue.campo !== '' && value.campo === '') || (operators.includes(oldValue.operador) && !operators.includes(value.operador))) {
        this.form.metadatos.value = this.form.metadatos.value.filter((x, i) => (x.campo !== '' && (x.valor !== '' || operators.includes(x.operador))) || i === index)
      }
    },
    reloadMetadataList: async function () {
      this.loadingMetadatos = true
      const respuestaMetadataClient = await getCamposMetadatos()
      if (respuestaMetadataClient.blnError) {
        this.finalListMetadatasClient = []
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', respuestaMetadataClient))
      } else {
        this.finalListMetadatasClient = respuestaMetadataClient.Respuesta
      }
      this.loadingMetadatos = false
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters['invoicesReceived/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.estado.value = _temp.estado !== undefined && _temp.estado.value !== '' ? _temp.estado.value : ''
        this.form.pendienteAprobacion.value = _temp.pendienteAprobacion !== undefined && _temp.pendienteAprobacion.value !== '' ? _temp.pendienteAprobacion.value : ''
        this.form.esOCREditable.value = _temp.esOCREditable !== undefined && _temp.esOCREditable.value !== '' ? _temp.esOCREditable.value : ''
        this.form.esTurnoUsuario.value = _temp.esTurnoUsuario !== undefined && _temp.esTurnoUsuario.value !== '' ? _temp.esTurnoUsuario.value : ''
        this.form.estadoExtraRecibidas.value = _temp.estadoExtraRecibidas !== undefined && _temp.estadoExtraRecibidas.value !== '' ? _temp.estadoExtraRecibidas.value : ''
        this.form.fechaFacturaDesde.value = _temp.fechaFacturaDesde !== undefined && _temp.fechaFacturaDesde.value !== '' ? _temp.fechaFacturaDesde.value : ''
        this.form.fechaFacturaHasta.value = _temp.fechaFacturaHasta !== undefined && _temp.fechaFacturaHasta.value !== '' ? _temp.fechaFacturaHasta.value : ''
        this.form.tipoInvoiceClass.value = _temp.tipoInvoiceClass !== undefined && _temp.tipoInvoiceClass.value !== '' ? _temp.tipoInvoiceClass.value : ''
        this.form.PGE.value = _temp.PGE !== undefined && _temp.PGE.value !== '' ? _temp.PGE.value : ''
        this.form.dirReceptor.value = _temp.dirReceptor !== undefined && _temp.dirReceptor.value !== '' ? _temp.dirReceptor.value : ''
        this.form.importeDesde.value = _temp.importeDesde !== undefined && _temp.importeDesde.value !== '' ? _temp.importeDesde.value : ''
        this.form.importeHasta.value = _temp.importeHasta !== undefined && _temp.importeHasta.value !== '' ? _temp.importeHasta.value : ''
        this.form.numFactura.value = _temp.numFactura !== undefined && _temp.numFactura.value !== '' ? _temp.numFactura.value : ''
        this.form.SerieFactura.value = _temp.SerieFactura !== undefined && _temp.SerieFactura.value !== '' ? _temp.SerieFactura.value : ''
        this.form.cifEmisor.value = _temp.cifEmisor !== undefined && _temp.cifEmisor.value !== '' ? _temp.cifEmisor.value : ''
        this.form.NombreCIFEmisor.value = _temp.NombreCIFEmisor !== undefined && _temp.NombreCIFEmisor.value !== '' ? _temp.NombreCIFEmisor.value : ''
        this.form.CodCliente.value = _temp.CodCliente !== undefined && _temp.CodCliente.value !== '' ? _temp.CodCliente.value : ''
        this.form.cifReceptor.value = _temp.cifReceptor !== undefined && _temp.cifReceptor.value !== '' ? _temp.cifReceptor.value : ''
        this.form.NombreCIFReceptor.value = _temp.NombreCIFReceptor !== undefined && _temp.NombreCIFReceptor.value !== '' ? _temp.NombreCIFReceptor.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.importe.value = _temp.importe !== undefined && _temp.importe.value !== '' ? _temp.importe.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''
        this.form.notas.value = _temp.notas !== undefined && _temp.notas.value !== '' ? _temp.notas.value : ''
        this.form.contieneAdjuntos.value = _temp.contieneAdjuntos !== undefined && _temp.contieneAdjuntos.value !== '' ? _temp.contieneAdjuntos.value : ''
        this.form.csv.value = _temp.csv !== undefined && _temp.csv.value !== '' ? _temp.csv.value : ''
        this.form.NumAsiento.value = _temp.NumAsiento !== undefined && _temp.NumAsiento.value !== '' ? _temp.NumAsiento.value : ''
        this.form.fechaAltaDesde.value = _temp.fechaAltaDesde !== undefined && _temp.fechaAltaDesde.value !== '' ? _temp.fechaAltaDesde.value : ''
        this.form.fechaAltaHasta.value = _temp.fechaAltaHasta !== undefined && _temp.fechaAltaHasta.value !== '' ? _temp.fechaAltaHasta.value : ''
        this.form.fechaPagoDesde.value = _temp.fechaPagoDesde !== undefined && _temp.fechaPagoDesde.value !== '' ? _temp.fechaPagoDesde.value : ''
        this.form.fechaPagoHasta.value = _temp.fechaPagoHasta !== undefined && _temp.fechaPagoHasta.value !== '' ? _temp.fechaPagoHasta.value : ''
        this.form.fechaRechazoDesde.value = _temp.fechaRechazoDesde !== undefined && _temp.fechaRechazoDesde.value !== '' ? _temp.fechaRechazoDesde.value : ''
        this.form.fechaRechazoHasta.value = _temp.fechaRechazoHasta !== undefined && _temp.fechaRechazoHasta.value !== '' ? _temp.fechaRechazoHasta.value : ''
        
        this.form.agrupacionCIF.value = _temp.agrupacionCIF !== undefined && _temp.agrupacionCIF.value !== '' ? _temp.agrupacionCIF.value : ''
        // this.form.agrupacionSede.value = _temp.agrupacionSede !== undefined && _temp.agrupacionSede.value !== '' ? _temp.agrupacionSede.value : ''
        // this.form.agrupacionOrganismo.value = _temp.agrupacionOrganismo !== undefined && _temp.agrupacionOrganismo.value !== '' ? _temp.agrupacionOrganismo.value : ''
        this.form.OrigenFactura.value = _temp.OrigenFactura !== undefined && _temp.OrigenFactura.value !== '' ? _temp.OrigenFactura.value : ''
        
        this.form.fechaEntradaERPDesde.value = _temp.fechaEntradaERPDesde !== undefined && _temp.fechaEntradaERPDesde.value !== '' ? _temp.fechaEntradaERPDesde.value : ''
        this.form.fechaEntradaERPHasta.value = _temp.fechaEntradaERPHasta !== undefined && _temp.fechaEntradaERPHasta.value !== '' ? _temp.fechaEntradaERPHasta.value : ''
        this.form.ultimoError.value = _temp.ultimoError !== undefined && _temp.ultimoError.value !== '' ? _temp.ultimoError.value : ''
        this.form.motivoRechazo.value = _temp.motivoRechazo !== undefined && _temp.motivoRechazo.value !== '' ? _temp.motivoRechazo.value : ''
        this.form.metadatos.value = _temp.metadatos?.value?.length ? _temp.metadatos.value.map(x => ({
          campo: x.campo !== '' ? x.campo : '',
          valor: x.valor !== '' ? x.valor : '',
          operador: x.operador !== 1 ? x.operador : 1,
        })) : [{ campo: '', valor: '', operador: 1, }]
        if (this.form.metadatos.value.every(x => x.campo && (x.valor || [4, 5].includes(x.operador))) && this.form.metadatos.value.length < this.maxMetadatosFilter) {
          this.form.metadatos.value.push({ campo: '', valor: '', operador: 1, })
        }
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        estado: { label: i18n.t('app.status'), value: '' },
        pendienteAprobacion: { label: i18n.t('tipos.estado_recibidas.wait_approving'), value: '' },
        esOCREditable: { label: 'Pendiente de revisión', value: '' },
        esTurnoUsuario: { label: 'Es turno', value: '' },
        estadoExtraRecibidas: { label: i18n.t('app.status'), value: '' },
        fechaFacturaDesde: { label: i18n.t('invoices.filters.invoice_date_from'), value: '' },
        fechaFacturaHasta: { label: i18n.t('invoices.filters.invoice_date_to'), value: '' },
        tipoInvoiceClass: { label: i18n.t('invoices.tipo_factura'), value: '' },
        PGE: { label: i18n.t('app.forma_envio'), value: '' },
        dirReceptor: { label: i18n.t('companies.configuration_rec.dir3_dire'), value: '' },
        importeDesde: { label: i18n.t('invoices.filters.invoice_importe_min'), value: '' },
        importeHasta: { label: i18n.t('invoices.filters.invoice_importe_max'), value: '' },
        numFactura: { label: i18n.t('invoices.num_factura'), value: '' },
        SerieFactura: { label: i18n.t('invoices.serie_factura'), value: '' },
        cifEmisor: { label: i18n.t('invoices.cif_emisor'), value: '' },
        NombreCIFEmisor: { label: i18n.t('invoices.emisor'), value: '' },
        CodCliente: { label: i18n.t('invoices.seller_client_code'), value: '' },
        cifReceptor: { label: i18n.t('invoices.cif_receptor'), value: '' },
        NombreCIFReceptor: { label: i18n.t('invoices.receptor'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        importe: { label: i18n.t('invoices.importe'), value: '' },
        nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
        nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
        notas: { label: i18n.t('invoices.notas'), value: '' },
        contieneAdjuntos: { label: i18n.t('invoices.adjuntos_included'), value: '' },
        csv: { label: i18n.t('invoices.csv'), value: '' },
        NumAsiento: { label: i18n.t('invoices.seat_number'), value: '' },
        fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        fechaEntradaERPDesde: { label: i18n.t('invoices.filters.erp_entry_date_from'), value: '' },
        fechaEntradaERPHasta: { label: i18n.t('invoices.filters.erp_entry_date_to'), value: '' },
        ultimoError: { label: i18n.t('invoices.error_temporal'), value: '' },
        motivoRechazo: { label: i18n.t('configurations.reject_msgs'), value: '' },
        metadatos: { label: i18n.tc('invoices.metadatos.metadato', 1), value: [{ campo: '', valor: '', operador: 1, }] },
        agrupacionCIF: { label: i18n.tc('grouping.grouping_companies', 1), value: '' },
        agrupacionCliente: { label: i18n.tc('grouping.grouping_buyers', 1), value: '' },
        agrupacionProveedor: { label: i18n.tc('grouping.grouping_sellers', 1), value: '' },
        OrigenFactura: { label: i18n.t('invoices.origen_factura'), value: '' },
        fechaPagoDesde: { label: i18n.t('invoices.filters.fecha_pago_from'), value: '' },
        fechaPagoHasta: { label: i18n.t('invoices.filters.fecha_pago_to'), value: '' },
        fechaRechazoDesde: { label: i18n.t('invoices.filters.fecha_rechazo_from'), value: '' },
        fechaRechazoHasta: { label: i18n.t('invoices.filters.fecha_rechazo_to'), value: '' },
      }
    },
    applyFilters: function () {
      this.cleanMultiples()
      this.cleanMetadatos(true)
      this.$store.commit('invoicesReceived/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    cleanMetadatos: function (apply) {
      const data = this.form.metadatos.value ? this.form.metadatos.value : null
      var filtered = data?.filter(x => (x?.valor || [4, 5].includes(x.operador)) && x?.campo && this.finalListMetadatasClient.some(y => y === x?.campo)) ?? []
      filtered = filtered.slice(0, this.maxMetadatosFilter)
      if (filtered.length === 0) {
        filtered = apply ? '' : [{ campo: '', valor: '', operador: 1, }]
      }
      this.form.metadatos.value = filtered
    },
    cleanMultiples: function () {
      if (Array.isArray(this.form.estadoExtraRecibidas.value) && this.form.estadoExtraRecibidas.value.length === 0) {
        this.form.estadoExtraRecibidas.value = ''
      }
      // if (Array.isArray(this.form.codPGN.value) && this.form.codPGN.value.length === 0) {
      //   this.form.codPGN.value = ''
      // }
    },
  }
}
</script>
